import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from "../classNames.js";
import { modifier, } from "../modifiers/index.js";
export const Columns = ({ className, children, gap, ...modifierProps }) => {
    const _class = classNames("columns", modifier(modifierProps), typeof gap === "number" ? `is-${gap}` : undefined, className);
    return _jsx("div", { className: _class, children: children });
};
